/* eslint-disable header/header */
export const name = "@azure/msal-angular";
export const version = "2.5.5";
